export default __webpack_public_path__ + "static/media/logo_square.774849c7.png";